import { AttributeNodeType } from './attribute.types';

// The attribute option (the connective hub) gets the brand tan; the three
// linked entity types each get a distinct colour.
export const NODE_COLORS: Record<AttributeNodeType, string> = {
  attribute_value: '#AB854A',
  product_category: '#16A34A',
  sub_profession: '#2D9CDB',
  sub_sub_profession: '#9333EA',
};

export const PENDING_COLORS = {
  added: '#16A34A',
  removed: '#DC2626',
};

export const nodeColor = (type: AttributeNodeType): string =>
  NODE_COLORS[type] ?? '#94A3B8';

export const nodeRadius = (type: AttributeNodeType): number =>
  (type === 'attribute_value' ? 9 : 7);

export const NODE_TYPE_LABELS: Record<AttributeNodeType, string> = {
  attribute_value: 'Attribute option',
  product_category: 'Product category',
  sub_profession: 'Sub-profession',
  sub_sub_profession: 'Area of focus',
};
